import { Injectable, ErrorHandler, inject } from '@angular/core';
import { AnalyticsHelper } from '../shared/analytics/analytics-helper';
import { AppConfig } from '../app.config';
import { isFrozenError } from '../shared/model/utility';

export const ERROR_KEY = 'unhandled-error';

// our global error handler
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly analytics = inject(AnalyticsHelper);

  handleError(error: Error) {
    try {
      this.analytics.logError(error, ERROR_KEY);
    } finally {
      if (AppConfig.isDebug && isFrozenError(error)) {
        console.error(
          '%c Debug: Frozen Object Mutation Detected ',
          'background: #ff0000; color: #fff; font-size: 14px; padding: 4px 8px;',
          '\n\nAttempted to mutate an object frozen via deepFreeze().',
          '\nFrozen objects are immutable — use spread/copy before modifying.',
          '\nSee: docs/guides/angular-modernization.md',
          '\n\nOriginal error:', error
        );
      } else {
        console.error('uncaught error:', error);
      }
    }
  }
}
